export default {"src":"/_next/static/image/public/images/ic_file_doc.0aaa64dcc74ce7bac7c9324312f69e2c.svg","height":24,"width":24};